<template>
  <div class="EmpEdit">
    <ld-header v-show="showHeader && simpleHeader">
      {{ title }}
    </ld-header>
    <div :class="className">
      <mescroll-vue
        ref="mescroll"
        :down="{ use: false }"
      >
        <div class="wrap">
          <van-cell-group>
            <van-cell><h4>基本信息</h4></van-cell>
            <van-field
              v-model="detail.empName"
              required
              :label="$t('D038','中文姓名')"
              placeholder="请输入名字"
              @blur.prevent="changeBlur"
            />

            <van-field
              v-show="showHeader"
              v-model="detail.engName"
              :label="$t('D039','英文姓名')"
              placeholder="请输入英文名字"
            />

            <van-field
              v-show="showHeader"
              v-model="detail.empNo"
              required
              label="员工编号"
              placeholder="请输入员工编号"
              @blur.prevent="changeBlur"
            />

            <van-field
              :label="$t('D017','国籍')"
              v-show="showHeader"
              v-model="detail.nationName"
              required
              is-link
              @click="$refs.nation.toggle()"
              input-align="left"
              readonly
            />

            <van-cell
              :title="$t('D016','性别')"
              title-class="van-field__label"
              required
            >
              <van-radio
                v-model="detail.sex"
                slot="right-icon"
                name="M"
              >
                {{ $t('D018', '男') }}
              </van-radio>
              <van-radio
                v-model="detail.sex"
                slot="right-icon"
                name="F"
              >
                {{ $t('D019', '女') }}
              </van-radio>
            </van-cell>

            <van-field
              :label="$t('D013','出生日期')"
              required
              readonly
              clickable
              placeholder="与证件保持一致"
              @click="dateShowAction('born')"
              :value="detail.born"
            />
            <van-field
              v-model="detail.phoneNumber"
              type="tel"
              required
              label="常用手机"
              placeholder="请填写手机号"
              :error-message="phoneErrMsg"
              @blur.prevent="changeBlur"
            />
          </van-cell-group>

          <van-cell-group>
            <van-cell><h4>职位信息</h4></van-cell>
            <van-field
              label="所在部门"
              v-model="detail.parDepts"
              required
              is-link
              @click="toggleDept"
              input-align="left"
              readonly
            />

            <van-field
              v-show="showHeader"
              label="差标等级"
              v-model="empRankName"
              is-link
              @click="empRankShow = true"
              input-align="left"
              readonly
            />
            <van-action-sheet
              v-show="showHeader"
              v-model="empRankShow"
              title="请选择差标等级"
              round
              :actions="empRankList"
              @select="empRankSelect"
              close-on-click-action
            />

            <van-cell
              v-show="showHeader"
              title="员工状态"
              required
              title-class="van-field__label"
            >
              <van-radio
                v-model="detail.isValid"
                slot="right-icon"
                :name="1"
              >
                在职
              </van-radio>
              <van-radio
                v-model="detail.isValid"
                slot="right-icon"
                :name="0"
              >
                离职
              </van-radio>
            </van-cell>
          </van-cell-group>

          <van-cell-group>
            <van-cell><h4>证件信息</h4></van-cell>
            <van-field
              v-model="detail.idNumber"
              label="身份证号"
              placeholder="与证件保持一致"
              clearable
              :error-message="idNumberErrMsg"
            />
            <van-field
              v-model="detail.passport"
              :label="$t('D005','护照')"
              placeholder="与证件保持一致"
              clearable
              @focus.prevent="changefocus"
            />
            <van-field
              label="护照有效期"
              readonly
              clickable
              placeholder="与证件保持一致"
              @click="dateShowAction('passportPeriod')"
              :value="detail.passportPeriod"
            />

            <van-field
              v-model="detail.otherNumber"
              label="其它证件"
              placeholder="与证件保持一致"
              clearable
              @focus.prevent="changefocus"
            />
            <van-field
              :label="$t('Q214','有效期')"
              readonly
              clickable
              placeholder="与证件保持一致"
              @click="dateShowAction('otherPeriod')"
              :value="detail.otherPeriod"
            />
          </van-cell-group>

          <van-cell-group title="如需完善员工详细资料，请联系管理员进行处理" />

          <ld-button
            @click="save"
            main3
            size="lg"
          >
            {{ $t('B010', '保存') }}
          </ld-button>
        </div>
      </mescroll-vue>
    </div>


    <ld-nation
      ref="nation"
      @selected="nationSelect"
    />

    <dept-list
      ref="dept"
      @selected="deptSelect"
    />

    <van-popup
      v-model="dateShow"
      position="bottom"
      :close-on-popstate="true"
      style="{ height: '40%' }"
    >
      <van-datetime-picker
        v-model="datepickModel"
        @confirm="datePickerConfirm"
        @cancel="dateShow = false"
        :min-date="minDate"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>
import {ActionSheet, Button, Cell, CellGroup, DatetimePicker, Field, NavBar, Popup, Radio} from 'vant'
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import {formatDate} from 'Utils/dateUtil'
import {changeBlur, changefocus} from 'Utils/tools'
import {validators} from 'Utils/valid'
import ldNation from 'Components/ldNation'
import deptList from 'Components/ldEmpList/deptList'
import MescrollVue from 'mescroll.js/mescroll.vue'
import {excludeSpecial} from 'Utils/string'
import {getIDcardInfo} from 'Utils/publicFun'

export default {
  name: 'EmpEdit',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [ActionSheet.name]: ActionSheet,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    ldHeader, ldButton, ldNation,
    deptList,
    MescrollVue
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '编辑员工信息'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    simpleHeader: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: 'wrapper'
    }
  },
  data() {
    return {
      d: '410926200112182012',
      detail: {
        isValid: 1,
        sex: 'M',
        parDepts: '',
        passportPeriod: ''
      },
      minDate: new Date('1900-01-01'),
      datepickModel: new Date(),
      dateShow: false,
      phoneErrMsg: '',
      idNumberErrMsg: '',
      empRankShow: false,
      empRankName: '',
      empRankList: [{loading: true}],
      currentCheckBorn: ''
    }
  },
  created() {
    if (this.id) {
      this.query()
    } else {
      this.title = '新增员工'
    }
    this.getEmpRank()
  },
  methods: {
    changeBlur,
    changefocus,
    async query() {
      let res = await this.$api['emp/vipEmpFindDetail']({
        empId: this.id
      })
      this.detail = res.data
      this.datepickModel = new Date(this.detail.born)
      this.getEmpRank()
    },
    getEmpRank() {
      //获取差标等级
      this.$api['common/vipJcsjbGetList']({lb: 11701}).then(res => {
        let emp = res.data || []
        if (res.data) {
          emp.forEach(rank => {
            rank.name = rank.svalue
          })
          this.empRankSelect(emp.find(rank => rank.sn == this.detail.empRank))
          this.empRankList = emp
        }
      })
    },
    empRankSelect(rank = {}) {
      this.detail.empRank = rank.sn
      this.empRankName = rank.svalue
    },
    //打开部门
    toggleDept() {
      this.$refs.dept.toggle()
    },
    deptSelect(info) {
      this.detail.deptId = info.id
      this.detail.parDepts = info.vipdeptName
      this.toggleDept()
    },
    nationSelect(nation) {
      this.$set(this.detail, 'nation', nation.id)
      this.$set(this.detail, 'nationName', nation.cName)
    },
    dateShowAction(row) {
      this.currentCheckBorn = row
      this.datepickModel = this.detail[this.currentCheckBorn]
        ? new Date(this.detail[this.currentCheckBorn])
        : new Date()
      this.dateShow = true
    },
    datePickerConfirm(date) {
      this.detail[this.currentCheckBorn] = formatDate(date).date
      this.dateShow = false
    },
    // 保存员工信息
    save() {
      let obj = {}
      if (this.showHeader === true) {
        obj = {
          empNo: '员工编号不能为空',
          empName: '姓名不能为空',
          nation: '国籍不能为空',
          deptId: '请选择部门',
          phoneNumber: '手机号不能为空'
        }
      } else {
        obj = {
          empName: '姓名不能为空',
          deptId: '请选择部门',
          phoneNumber: '手机号不能为空'
        }
      }
      for (let key in obj) {
        let validtor = validators['is-string'](this.detail[key])
        if (!validtor.valid) {
          this.$validErrorTips(obj[key])
          return false
        }
      }
      if (this.phoneErrMsg !== '') return
      if (
        !this.detail.idNumber &&
        !this.detail.passport &&
        !this.detail.otherNumber
      ) {
        this.$validErrorTips('证件号码不能为空')
        return false
      }
      if (this.idNumberErrMsg !== '') return
      if (this.detail.passport) {
        if (!this.detail.passportPeriod) {
          this.$validErrorTips('请输入护照有效期')
          return false
        }
      }
      if (this.detail.otherNumber) {
        if (!this.detail.otherPeriod) {
          this.$validErrorTips('请输入其它证件有效期')
          return false
        }
      }
      if (this.showHeader === true && this.id) {
        this.vipEmpEditDetail()
      } else if (!this.id) {
        this.vipEmpSaveDetail()
      }
    },
    //简易新增员工
    vipEmpSaveDetail() {
      this.$api['emp/vipEmpSaveDetail'](this.detail).then(() => {
        this.$dialog.alert({message: '新增成功'}).then(() => {
          if (this.showHeader === true && this.id) {
            this.$router.back()
          } else if (this.simpleHeader === false && !this.id) {
            this.$emit('call-back', false)
            this.detail = {
              isValid: 1,
              sex: 'M',
              parDepts: '',
              passportPeriod: '',
              phoneNumber: '',
              idNumber: '',
              born: '',
              otherPeriod: '',
              passport: '',
              nation: '',
              nationName: '',
              deptId: '',
              empRank: '',
              empNo: '',
              engName: '',
              empName: ''
            }
            this.empRankName = ''
          } else if (!this.id) {
            this.$router.back()
          }
        })
      })
    },
    //
    vipEmpEditDetail() {
      this.$api['emp/vipEmpEditDetail'](this.detail).then((res) => {
        this.$dialog({message: '编辑成功'}).then(() => {
          this.$router.go(-1)
        })
      })
    }
  },
  watch: {
    'detail.phoneNumber': function (val) {
      this.detail.phoneNumber = excludeSpecial(val)
      if (!validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'detail.idNumber': function (val) {
      this.detail.idNumber = excludeSpecial(val)
      if (val && !validators['is-idCard'](val).valid) {
        this.idNumberErrMsg = validators['is-idCard'](val).msg
      } else {
        this.idNumberErrMsg = ''
      }
      if (!this.detail.born && this.detail.idNumber && !this.idNumberErrMsg) {
        this.detail.born = getIDcardInfo(this.detail.idNumber).born
      }
    }
  }
}
</script>

<style lang="less">
.EmpEdit {
  h4 {
    margin: 0;
  }

  .van-cell__title + .van-radio {
    padding-right: 20px;
  }

  .wrap {
    padding: 10px 6px;
  }

  .wrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
  }

  .wrapper1 {
    height: calc(100vh - 100px);
    overflow: hidden;
  }
}
</style>

